
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_17454_5346)"}},[_c('path',{attrs:{"d":"M1.214 10.786h0a1.175 1.175 0 010-1.662l-.053-.053.053.053L9.17 1.17a1.175 1.175 0 011.662 0l7.955 7.955.053-.053-.053.053a1.175 1.175 0 010 1.662h0a1.175 1.175 0 01-1.662 0l-.053.053.053-.053-7.071-7.071L10 3.662l-.053.053-7.071 7.07.053.054-.053-.053a1.175 1.175 0 01-1.662 0z","fill":"#fff","stroke":"#A3A3A3","stroke-width":".15"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_17454_5346"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v12H0z"}})])])])
          )
        }
      }
    